<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Address Detail"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="detailForm"
                :rules="rules"
                :model="detailForm"
                disabled
            >
                <el-col :span="24">
                    <el-form-item label="Name" size="small" prop="name">
                        <el-input
                            clearable
                            size="small"
                            v-model="detailForm.name"
                            placeholder="Firstname"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="Street Address"
                        size="small"
                        prop="street1"
                    >
                        <el-input
                            clearable
                            size="small"
                            v-model="detailForm.street1"
                            placeholder="Street1"
                        ></el-input>
                        <el-input
                            clearable
                            size="small"
                            v-model="detailForm.street2"
                            placeholder="Street2"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Country" size="small" prop="country">
                        <el-select
                            v-model="detailForm.country"
                            size="mini"
                            placeholder="Please select"
                            filterable
                            clearable
                        >
                            <el-option
                                v-for="item in countryList"
                                :key="item.id"
                                :label="item.name_en"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="State/Province"
                        size="small"
                        prop="state"
                    >
                        <el-input
                            clearable
                            size="small"
                            v-model="detailForm.state"
                            placeholder="State/Province"
                        ></el-input>
                        <!-- <el-select
              v-model="detailForm.state"
              size="mini"
              placeholder="Please select"
              filterable
              clearable
            >
              <el-option
                v-for="item in []"
                :key="item.id"
                :label="item.code"
                :value="item.code"
              ></el-option>
                        </el-select>-->
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="City" size="small" prop="city">
                        <el-input
                            clearable
                            size="small"
                            v-model="detailForm.city"
                            placeholder="City"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="Zip/Postal Code"
                        size="small"
                        prop="postal_code"
                    >
                        <el-input
                            clearable
                            size="small"
                            v-model="detailForm.postal_code"
                            placeholder="Postal Code"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="Phone Number"
                        size="small"
                        prop="Phone"
                    >
                        <el-input
                            clearable
                            size="small"
                            v-model="detailForm.phone"
                            placeholder="Phone"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item size="small">
                        <el-checkbox
                            v-model="detailForm.default"
                            :true-label="1"
                            :false-label="0"
                            label="Set as default address"
                        ></el-checkbox>
                    </el-form-item>
                </el-col>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="detailVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            detailForm: {
                name: "",
                country: "",
                state: "",
                city: "",
                street1: "",
                street2: "",
                phone: "",
                email: "",
                postal_code: "",
                house_number: "",
                default: 1,
                tag: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        trigger: "blur",
                    },
                ],
                street1: [
                    {
                        required: true,
                        trigger: "blur",
                    },
                ],
                country: [
                    {
                        required: true,
                        trigger: "change",
                    },
                ],
                state: [
                    {
                        required: false,
                        trigger: "change",
                    },
                ],
                city: [
                    {
                        required: true,
                        trigger: "blur",
                    },
                ],
                postal_code: [
                    {
                        required: true,
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: false,
                        trigger: "blur",
                    },
                ],
            },
            loading: false,
            countryList: [],
        };
    },
    methods: {
        ...mapActions(["getCountrySelect"]),
        addressBook() {
            cmofferApi.addressBook({}, "get", this.tableItem.id).then((res) => {
                if (res) {
                    this.detailForm = { ...res.data };
                    this.detailForm.country = +this.detailForm.country;
                }
            });
        },
        closeDialog() {
            this.detailForm = {};
            this.$refs["detailForm"].clearValidate();
            this.$refs["detailForm"].resetFields();
            this.$emit("update:detailVisible", false);
        },
        async initialize() {
            console.log(this.tableItem);
            this.getCountrySelect().then((res) => {
                this.countryList = res.data;
            });
            this.addressBook();
        },
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
    },
    watch: {
        detailVisible() {
            if (this.detailVisible) {
                this.initialize();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.detail {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }

        .el-select {
            width: 100%;
        }

        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
    }
    /* ::v-deep .el-dialog__footer {
        text-align: center !important;
    } */
}
</style>
